<ph-dialog open [heading]="title" (ph-close)="cancel()">
    <p *ngIf="isAchCancellation; else voidCheck">
        This action will cancel the ACH payment to this vendor.
        Are you sure you want to continue?
    </p>

    <ng-template #voidCheck>
        <ph-alert status="information">
            <ng-container *ngIf="isMarkedAsPaid; else checkVoidCopy">
                This only records this payment as voided in PayHOA.
                Since the payment was made outside of PayHOA, you will also need to reverse it directly with your bank or the vendor.
            </ng-container>
            <ng-template #checkVoidCopy>
                This only records the check as voided in PayHOA.
                To ensure the check cannot be cashed, you will also need to request a stop payment through your bank.
            </ng-template>
        </ph-alert>
        <form [formGroup]="form">
            <ph-field>
                <ph-label>Void Date</ph-label>
                <ph-date-input formControlName="cancellationDate" ngDefaultControl [max]="maxDateStr"></ph-date-input>
                <ph-hint>Select the date to reflect the void date in the reversal transaction.</ph-hint>
            </ph-field>
        </form>
    </ng-template>

    <ph-actions slot="footer" align="between">
        <ph-button variant="secondary" mode="filled" (click)="cancel()">Cancel</ph-button>
        <ph-button variant="error" mode="filled" (click)="confirm()">{{ confirmButtonText }}</ph-button>
    </ph-actions>
</ph-dialog>
